<template>
	<div :class="wrapperClass">

		<!-- <div v-show="!hostedFieldsInstance" class="loader" id="loader-1"> -->
		<v-layout column align-center justify-center v-if="!hostedFieldsInstance" style="width: 100%; height: 150px;">
			<!-- <img class="loading-page-graphic" ref="loadingPageGraphic" src="/static/images/loading/wrkprty-fast.gif" width="100" style="margin: 0 auto;"> -->
			<p>Loading</p>
			<i class="fal fa-spinner rotation success--text" style="font-size: 5.0em;"></i>
		</v-layout>

		<div v-show="hostedFieldsInstance">
			
			<!-- <div class="line" v-if="collectCardHolderName">
				<label for="cardholder">Card Holder
					<input type="text" class="input-field" id="cardholder" name="cardholder" placeholder="Name">
				</label>
			</div> -->

			<label class="hosted-field--label" for="number">Card Number</label>
			<div id="number" class="hosted-field"></div>
			
			<v-layout row wrap>
				<v-flex xs12 sm6 class="pr-1">
					<label class="hosted-field--label" for="expiration-date">Expiration Date</label>
					<div id="expiration-date" class="hosted-field"></div>
				</v-flex>
				<v-flex xs12 sm6 class="pl-1">
					<label class="hosted-field--label" for="cvv">CVV</label>
					<div id="cvv" class="hosted-field"></div>
				</v-flex>
			</v-layout>
		</div>

	</div>
</template>

<script>
const hostedFields = require('braintree-web/hosted-fields')
const client = require('braintree-web/client')
import { findElementByLabel } from '~/utils/helper'
export default {
	props: {
		tokenize: {
			value: Boolean
		},
		authToken: {
			value: String
		},
		wrapperClass: {
			value: String
		},
		loaderClass: {
			value: String
		},
		inputClass: {
			value: String
		},
		collectCardHolderName: {
			value: Boolean
		},
		collectPostalCode: {
			value: Boolean
		},
		enableDataCollector: {
			value: Boolean
		}
	},
	created() {
		this.createBT()
	},
	watch: {
		tokenize(newValue) {
			if (newValue) {
				console.log('hostedFields tokenize')
				this.tokenizeHF()
				this.$emit('tokenized')
			}
		}
	},
	data() {
		return {
			errorMessage: '',
			clientInstance: '',
			hostedFieldsInstance: null,
			tokenizePayload: '',
			dataCollectorPayload: ''
		}
	},
	methods: {
		createBT() {
			client.create(
				{
					authorization: this.authToken
				},
				(clientErr, clientInstance) => {
					if (clientErr) {
						this.errorMessage =
							'There was an error setting up the client instance. Message: ' +
							clientErr.message
						this.$emit('bthferror', this.errorMessage)
						// return
					} else {
						this.clientInstance = clientInstance
						this.createHF()
						if (this.enableDataCollector) {
							this.dataCollectorCreate()
						}
					}
				}
			)
		},
		createHF() {
			hostedFields.create(
				{
					client: this.clientInstance,
					styles: {
						input: {
							'font-size': '16px',
							'font-family': 'roboto, verdana, sans-serif',
							'font-weight': 'lighter',
							color: 'black'
						},
						':focus': {
							color: 'black'
						},
						'.valid': {
							color: 'black'
						},
						'.invalid': {
							color: 'black'
						}
					},
					fields: {
						number: {
							selector: '#number'
							// placeholder: '4111 1111 1111 1111',
						},
						cvv: {
							selector: '#cvv'
							// placeholder: '123',
						},
						expirationDate: {
							selector: '#expiration-date'
							// placeholder: '10/2019',
						}
					}
				},
				(hostedFieldsErr, hostedFieldsInstance) => {
					if (hostedFieldsErr) {
						// Handle error in Hosted Fields creation
						this.errorMessage =
							'There was an error setting up the hosted fields! Message: ' +
							hostedFieldsErr.message
						this.$emit('bthferror', this.errorMessage)
						// return
					} else {
						this.$emit('bthfready')
						this.hostedFieldsInstance = hostedFieldsInstance

						hostedFieldsInstance.on('focus', event => {
							var field = event.fields[event.emittedBy]
							let element = findElementByLabel(field)
							element.classList.add('label-float')
							element.classList.remove('filled')
						})
						hostedFieldsInstance.on('blur', function(event) {
							var field = event.fields[event.emittedBy]
							var element = findElementByLabel(field)

							if (field.isEmpty) {
								element.classList.remove('label-float')
							} else if (field.isValid) {
								element.classList.add('filled')
							} else {
								element.classList.add('invalid')
							}
						})
						hostedFieldsInstance.on('empty', function(event) {
							var field = event.fields[event.emittedBy]

							var element = findElementByLabel(field)
							element.classList.remove('filled')
							element.classList.remove('invalid')
						})
						hostedFieldsInstance.on('validityChange', function(event) {
							var field = event.fields[event.emittedBy]
							var element = findElementByLabel(field)

							if (field.isPotentiallyValid) {
								element.classList.remove('invalid')
							} else {
								element.classList.add('invalid')
							}
						})
					}
				}
			)
		},
		tokenizeHF() {
			// const additionalFields = {
			// 	cardholderName: '',
			// 	billingAddress: {
			// 		postalCode: '',
			// 	},
			// }
			// if (this.collectCardHolderName) {
			// 	additionalFields.cardholderName = document.querySelector('#cardholder').value
			// }
			// if (this.collectPostalCode) {
			// 	additionalFields.billingAddress.postalCode = document.querySelector('#postal').value
			// }
			// console.log(additionalFields)
			// this.hostedFieldsInstance.tokenize(additionalFields, (tokenizeErr, payload) => {
			this.hostedFieldsInstance.tokenize((tokenizeErr, payload) => {
				if (tokenizeErr) {
					this.errorMessage =
						'There was an error tokenizing! Message: ' + tokenizeErr.message
					this.$emit('bthferror', this.errorMessage)
					return
				}
				this.tokenizePayload = payload
				this.$emit('bthfpayload', payload)
				this.teardownHF()
			})
		},
		teardownHF() {
			this.hostedFieldsInstance.teardown(teardownErr => {
				if (teardownErr) {
					this.errorMessage =
						'There was an error tearing it down! Message: ' +
						teardownErr.message
					this.$emit('bthferror', this.errorMessage)
					// return
				} else {
					this.hostedFieldsInstance = ''
					setTimeout(() => {
						this.createBT()
					}, 1000)
					// return
				}
			})
		},
		dataCollectorCreate() {
			const dataCollector = require('braintree-web/data-collector')
			dataCollector.create(
				{
					client: this.clientInstance,
					kount: true
				},
				(dataCollectorErr, dataCollectorInstance) => {
					console.log('dataCollectorCreate')
					console.log(dataCollectorErr)
					if (dataCollectorErr) {
						this.errorMessage =
							'There was an error setting up the data collector! Message: ' +
							dataCollectorErr.message
						this.$emit('bthferror', this.dataCollectorErr)
						return
					}
					this.$emit('device.data.payload', dataCollectorInstance.deviceData)
					this.dataCollectorPayload = dataCollectorInstance
				}
			)
		}
	}
}
</script>

<style lang="scss">
@-webkit-keyframes rotation {
	from {
		-webkit-transform: rotate(0deg);
	}
	to {
		-webkit-transform: rotate(359deg);
	}
}
.rotation {
	-webkit-animation: rotation 2s infinite linear;
}
.hosted-field--label {
	transform: translateY(0.4em);
	font-size: 0.85em;
	line-height: 32px;
	transition: all 0.15s ease-out;
	color: #999;
	display: block;
	width: 100%;
	font-weight: 400;
	overflow: hidden;
	margin-bottom: 0em;
	&.label-float {
		text-overflow: ellipsis;
		color: #74cbf1;
		transition: all 0.15s ease-out;
	}
	&.filled {
		@extend .label-float;
		color: rgba(0, 0, 0, 0.54);
	}
	&.invalid {
		@extend .label-float;
		color: #de6455;
	}
}
.hosted-field {
	height: 32px;
	margin-bottom: 0.5em;
	display: block;
	background-color: transparent;
	color: rgba(0, 0, 0, 0.87);
	border: none;
	border-bottom: 1px solid rgba(0, 0, 0, 0.54);
	outline: 0;
	width: 100%;
	font-size: 16px;
	padding: 0;
	box-shadow: none;
	border-radius: 0;
	position: relative;
}
.braintree-hosted-fields-focused {
	border-bottom: 2px solid #74cbf1;
	transition: all 200ms ease;
}

.braintree-hosted-fields-invalid {
	border-bottom: 2px solid #de6455;
	transition: all 200ms ease;
}
</style>
